/* eslint-disable */

import { Card, CardContent, Checkbox, Button, List, ListItem, Stack, Typography, Tabs, Tab, Box, Grid, TextField,
  Dialog, DialogTitle, List as MUIList, ListItemButton, ListItemText } from "@mui/material";
import Divider from '@mui/material/Divider';
import { MobXProviderContext, Observer, observer } from "mobx-react";
import PropTypes from 'prop-types';
import React, { useEffect, useRef } from "react";
import EnviarPedidosDialog from "./enviarPedidos";
import NaoHaPedidos from "./naoHaPedidos";
import Pedido from "./pedido";
import SelecionarEntregadorDialog from "./selecionarEntregadorFlex";
import ListaRotas from "./listaRotas";
import { Search, Add } from "@mui/icons-material";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ paddingTop: 1 }}>
          {children}
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

function useDebounce(cb, delay) {
  const [debounceValue, setDebounceValue] = React.useState(cb);
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebounceValue(cb);
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [cb, delay]);
  return debounceValue;
}

function ListaPedidos(props) {
  const { mapaStore } = React.useContext(MobXProviderContext);
  // Aba atual vem do store (permite trocar de aba a partir dos diálogos).
  const value = mapaStore.tabIndex;
  const [filtro, setfiltro] = React.useState("");
  const [debounceVal, setDebounceVal] = React.useState("");

  const debounceValue = useDebounce(filtro, 800);

  const listaRef = useRef(null);

  useEffect(() => {
    mapaStore.setFiltro(filtro);
    mapaStore.buscarPedidos(true);
  }, [debounceValue]);

  const handleChangeFiltro = (e) => {
    setfiltro(e.target.value);
  };

  const handleKeyDownFiltro = (e) => {
    if (e.key === 'Enter') {
      // selecionarPorEnter do Flutter (aceita "23,53,22").
      mapaStore.selecionarPorEnterFlex();
    }
  };

  const handleChange = (event, newValue) => {
    mapaStore.setTabIndex(newValue);
  };

  // Modo flexível (ModoDistribuicao=1) => abas novas com "Rotas". Modo
  // restritivo (padrão) => ordem ORIGINAL de abas (sem Rotas). O índice de cada
  // aba é derivado do modo, então store e UI ficam sempre consistentes.
  const flex = mapaStore.distribuicaoFlexivel;
  const tabKeys = flex
    ? ['pendentes', 'rotas', 'aCaminho', 'entregues', 'cancelados']
    : ['pendentes', 'aCaminho', 'entregues', 'cancelados'];
  const idx = (k) => tabKeys.indexOf(k);

  // Vai para a aba Rotas depois de criar/alimentar uma rota.
  const irParaRotas = () => {
    mapaStore.setTabIndex(idx('rotas'));
  };

  // Botão "Criar rota" (aba Pendentes): se já há rotas, pergunta se cria uma
  // nova ou adiciona a seleção a uma rota existente.
  const [dialogRotaAberto, setDialogRotaAberto] = React.useState(false);

  const handleCriarRota = () => {
    if (mapaStore.rotas.length === 0) {
      mapaStore.criarRotaComSelecionados();
      irParaRotas();
      return;
    }
    setDialogRotaAberto(true);
  };

  useEffect(() => {
  }, []);

  useEffect(() => {
    if (listaRef.current && listaRef.current.scrollTop > 0) {
      setTimeout(() => {
        listaRef.current?.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      }, 1000);
    }
  }, [mapaStore.pedidosACaminho]); // Dispara sempre que a lista mudar

  var height = window.innerHeight

  return (
    <div style={{ position: 'relative', width: '100%' }}>
      <div
        style={{ position: 'absolute', width: '30%', height: `${height - 160}px`, zIndex: '1000' }}
      >
        <Card style={{ height: '100%', margin: '32px', padding: 0, }}>
          <CardContent style={{ padding: 0 }}>
            <Typography gutterBottom variant="h6" component="div" style={{ marginLeft: 5, paddingTop: 10, paddingLeft: 8 }}>
              Pedidos
            </Typography>
            <Observer >{() =>
              <Tabs style={{ padding: 2 }} value={value} onChange={handleChange} variant="scrollable" scrollButtons="auto" aria-label="abas status pedido">
                <Tab label={`Pendentes`} value={idx('pendentes')} iconPosition="bottom" icon={
                  <Box style={{ backgroundColor: "#8bad0d", color: "#fff", borderRadius: '16px', minWidth: '25px'}}>
                    {mapaStore.pedidosAvulsos.length}
                  </Box>
                }  {...a11yProps(idx('pendentes'))} style={{ fontSize: 14, flexDirection: 'column' }} />
                {flex &&
                  <Tab label={`Rotas`} value={idx('rotas')} iconPosition="bottom" icon={
                    <Box style={{ backgroundColor: "#8bad0d", color: "#fff", borderRadius: '16px', minWidth: '25px'}}>
                      {mapaStore.qtdRotas}
                    </Box>
                  } {...a11yProps(idx('rotas'))} style={{ fontSize: 14, flexDirection: 'column'  }} />
                }
                <Tab label={`A Caminho`} value={idx('aCaminho')} iconPosition="bottom" icon={
                  <Box style={{ backgroundColor: "#8bad0d", color: "#fff", borderRadius: '16px', minWidth: '25px'}}>
                    {mapaStore.pedidosACaminho.length}
                  </Box>
                } {...a11yProps(idx('aCaminho'))} style={{ fontSize: 14, flexDirection: 'column'  }} />
                <Tab label={`Entregues`} value={idx('entregues')} iconPosition="bottom" icon={
                  <Box style={{ backgroundColor: "#8bad0d", color: "#fff", borderRadius: '16px', minWidth: '25px'}}>
                    {mapaStore.pedidosFinalizados.length}
                  </Box>
                } {...a11yProps(idx('entregues'))} style={{ fontSize: 14, flexDirection: 'column'  }} />
                <Tab label={`Cancelados`} value={idx('cancelados')} iconPosition="bottom" icon={
                  <Box style={{ backgroundColor: "#8bad0d", color: "#fff", borderRadius: '16px', minWidth: '25px'}}>
                    {mapaStore.pedidosCancelados.length}
                  </Box>
                } {...a11yProps(idx('cancelados'))} style={{ fontSize: 14, flexDirection: 'column'  }} />
              </Tabs>
            }</Observer>

            <Observer >{() =>
              <TabPanel style={{ backgroundColor: '#eaeaea' }} value={value} index={idx('pendentes')}>
                <Stack
                  direction="row"
                  justifyContent="center"
                  alignItems="stretch"
                  spacing={2}
                >
                  <Button onClick={() => mapaStore.makeRoute()}
                    disabled={!mapaStore.pedidosSelecionados ||
                      !mapaStore.pedidosSelecionados[mapaStore.tabIndex] ||
                      mapaStore.pedidosSelecionados[mapaStore.tabIndex].length < 1}>
                    Exibir rota
                  </Button>
                  {flex &&
                    <Button onClick={handleCriarRota}
                      disabled={!mapaStore.pedidosSelecionados ||
                        !mapaStore.pedidosSelecionados[0] ||
                        mapaStore.pedidosSelecionados[0].length < 1 ||
                        mapaStore.inProgress}>
                      Criar rota
                    </Button>
                  }
                  <SelecionarEntregadorDialog />
                  <Button onClick={() => mapaStore.definirStatus(5)}
                    disabled={!mapaStore.pedidosSelecionados ||
                      !mapaStore.pedidosSelecionados[mapaStore.tabIndex] ||
                      mapaStore.pedidosSelecionados[mapaStore.tabIndex].length < 1}>
                    Finalizar pedidos
                  </Button>
                  {/* <EnviarPedidosDialog /> */}
                </Stack>

                <Stack
                  direction="row"
                  justifyContent="center"
                  alignItems="stretch"
                  spacing={1}
                  paddingLeft={3}
                  paddingRight={3}
                >
                  <Card style={{ width: '100%' }}>
                    <Stack direction="row" paddingLeft={1}
                      paddingBottom={1}>
                      <TextField fullWidth id="outlined-basic" label="Filtrar" variant="standard" type="text" value={filtro} onChange={handleChangeFiltro} onKeyDown={handleKeyDownFiltro} />
                      <Search sx={{ color: 'action.active', mt: 1.8, mx: 1 }} />
                    </Stack>
                  </Card>
                </Stack>

                <List ref={listaRef} sx={{ backgroundColor: '#eaeaea', width: '100%', maxHeight: height - 310, overflow: 'auto', paddingTop: 1 }}>
                  {mapaStore.pedidosAvulsosVisiveis.length > 0 ? mapaStore.pedidosAvulsosVisiveis.map((pedido) => (
                    <ListItem key={pedido.id}>
                      <Pedido pedido={pedido} />
                    </ListItem>
                  )) : <NaoHaPedidos />}
                </List>

              </TabPanel>
            }</Observer>


            <Observer >{() =>
              <TabPanel style={{ backgroundColor: '#eaeaea' }} value={value} index={idx('aCaminho')}>
                <Stack
                  direction="row"
                  justifyContent="center"
                  alignItems="stretch"
                  spacing={1}
                >
                  {/* No modo flexível, "Cancelar" = remover o motoca e devolver
                      os pedidos para Pendentes (avulsos). No modo restritivo,
                      mantém o comportamento antigo (cancela a entrega). */}
                  <Button onClick={() => mapaStore.distribuicaoFlexivel
                    ? mapaStore.removerEntregadorDosSelecionados()
                    : mapaStore.definirStatus(0)}
                    disabled={!mapaStore.pedidosSelecionados ||
                      !mapaStore.pedidosSelecionados[mapaStore.tabIndex] ||
                      mapaStore.pedidosSelecionados[mapaStore.tabIndex].length < 1 ||
                      mapaStore.inProgress}>
                    {mapaStore.distribuicaoFlexivel ? 'Devolver p/ Pendentes' : 'Cancelar Entrega'}
                  </Button>
                  <Button onClick={() => mapaStore.definirStatus(5)}
                    disabled={!mapaStore.pedidosSelecionados ||
                      !mapaStore.pedidosSelecionados[mapaStore.tabIndex] ||
                      mapaStore.pedidosSelecionados[mapaStore.tabIndex].length < 1}>
                    Finalizar pedidos
                  </Button>

                </Stack>

                <Stack
                  direction="row"
                  justifyContent="center"
                  alignItems="stretch"
                  spacing={1}
                  paddingLeft={3}
                  paddingRight={3}
                >
                  <Card style={{ width: '100%' }}>
                    <Stack direction="row" paddingLeft={1}
                      paddingBottom={1}>
                      <TextField fullWidth id="outlined-basic" label="Filtrar" variant="standard" type="text" value={filtro} onChange={handleChangeFiltro} onKeyDown={handleKeyDownFiltro} />
                      <Search sx={{ color: 'action.active', mt: 1.8, mx: 1 }} />
                    </Stack>
                  </Card>
                </Stack>

                <List ref={listaRef} sx={{ backgroundColor: '#eaeaea', width: '100%', maxHeight: height - 310, overflow: 'auto', paddingTop: 1 }}>
                  {mapaStore.pedidosACaminhoVisiveis.length > 0 ? mapaStore.pedidosACaminhoVisiveis.map((pedido) => (
                    <ListItem key={pedido.id}>
                      <Pedido pedido={pedido} />
                    </ListItem>
                  )) : <NaoHaPedidos />}
                </List>

              </TabPanel>
            }</Observer>


            <Observer >{() =>
              <TabPanel style={{ backgroundColor: '#eaeaea' }} value={value} index={idx('entregues')}>
                <List ref={listaRef} sx={{ backgroundColor: '#eaeaea', width: '100%', maxHeight: height - 220, overflow: 'auto', paddingTop: 1 }}>
                  <Stack
                    direction="row"
                    justifyContent="center"
                    alignItems="stretch"
                    spacing={1}
                    paddingLeft={3}
                    paddingRight={3}
                  >
                    <Card style={{ width: '100%' }}>
                      <Stack direction="row" paddingLeft={1}
                        paddingBottom={1}>
                        <TextField fullWidth id="outlined-basic" label="Filtrar" variant="standard" type="text" value={filtro} onChange={handleChangeFiltro} onKeyDown={handleKeyDownFiltro} />
                        <Search sx={{ color: 'action.active', mt: 1.8, mx: 1 }} />
                      </Stack>
                    </Card>
                  </Stack>

                  {mapaStore.pedidosFinalizadosVisiveis.length > 0 ? mapaStore.pedidosFinalizadosVisiveis.map((pedido) => (
                    <ListItem key={pedido.id}>
                      <Pedido pedido={pedido} />
                    </ListItem>
                  )) : <NaoHaPedidos />}
                </List>
              </TabPanel>
            }</Observer>


            <Observer >{() =>
              <TabPanel style={{ backgroundColor: '#eaeaea' }} value={value} index={idx('cancelados')}>
                <List ref={listaRef} sx={{ backgroundColor: '#eaeaea', width: '100%', maxHeight: height - 265, overflow: 'auto', paddingTop: 1 }}>
                  <Stack
                    direction="row"
                    justifyContent="center"
                    alignItems="stretch"
                    spacing={1}
                    paddingLeft={3}
                    paddingRight={3}
                  >
                    <Card style={{ width: '100%' }}>
                      <Stack direction="row" paddingLeft={1}
                        paddingBottom={1}>
                        <TextField fullWidth id="outlined-basic" label="Filtrar" variant="standard" type="text" value={filtro} onChange={handleChangeFiltro} onKeyDown={handleKeyDownFiltro} />
                        <Search sx={{ color: 'action.active', mt: 1.8, mx: 1 }} />
                      </Stack>
                    </Card>
                  </Stack>

                  {mapaStore.pedidosCanceladosVisiveis.length > 0 ? mapaStore.pedidosCanceladosVisiveis.map((pedido) => (
                    <ListItem key={pedido.id}>
                      <Pedido pedido={pedido} />
                    </ListItem>
                  )) : <NaoHaPedidos />}
                </List>
              </TabPanel>
            }</Observer>

            {/* Aba Rotas: pedidos pendentes agrupados por Rota, aguardando motoca */}
            <Observer >{() =>
              <TabPanel style={{ backgroundColor: '#eaeaea' }} value={value} index={idx('rotas')}>
                <Stack
                  direction="row"
                  justifyContent="center"
                  alignItems="stretch"
                  spacing={1}
                  paddingLeft={3}
                  paddingRight={3}
                >
                  <ListaRotas maxHeight={height - 265} />
                </Stack>
              </TabPanel>
            }</Observer>

            <div style={{ height: '100vh', backgroundColor: "#eaeaea" }}></div>
          </CardContent>
        </Card>
      </div>

      {/* "Criar rota" com rotas já existentes: nova rota ou adicionar a uma delas */}
      <Observer>{() =>
        <Dialog open={dialogRotaAberto} onClose={() => setDialogRotaAberto(false)}>
          <DialogTitle>Adicionar seleção a...</DialogTitle>
          <MUIList sx={{ minWidth: 320 }}>
            <ListItemButton onClick={() => {
              mapaStore.criarRotaComSelecionados();
              setDialogRotaAberto(false);
              irParaRotas();
            }}>
              <Add fontSize="small" style={{ marginRight: 8 }} />
              <ListItemText primary="Nova rota" />
            </ListItemButton>
            <Divider />
            {mapaStore.rotas.map((r) => (
              <ListItemButton key={r.numero} onClick={() => {
                mapaStore.adicionarSelecionadosNaRota(r);
                setDialogRotaAberto(false);
                irParaRotas();
              }}>
                <ListItemText
                  primary={`Rota #${r.numero} · ${r.quantidade} pedido(s)` +
                    (r.temEntregador ? ` · ${r.entregadorNome}` : '')}
                />
              </ListItemButton>
            ))}
          </MUIList>
        </Dialog>
      }</Observer>
    </div>
  )
}

export default observer(ListaPedidos);
